import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { abbreviateLocation } from '../../../utils/locationSearch.util';
import { LinkWithTracking } from '../../LinkWithTracking/LinkWithTracking';

type Props = {
  locationInputVal: any;
  stateCode: any;
  zipCode: any;
  setIsOpenMobileLocation: any;
};
export const MobileSetLocation = ({
  locationInputVal,
  stateCode,
  zipCode,
  setIsOpenMobileLocation,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Layout.Group css={{ paddingBottom: '12px', paddingTop: '8px' }}>
      <Flex alignItems="center">
        <Text
          css={{
            marginTop: '2px',
            color: '$core.color.brand.100',
            fontSize: '12px',
            fontWeight: '700',
            lineHeight: '14px',
          }}
        >
          {t('PCP_LOCATION.SET_LOCATION')}
        </Text>
        <IconSymbol
          color="$core.color.brand.100"
          css={{
            'abyss-icon-symbol': {
              width: '18px',
              height: '18px',
            },
          }}
          icon="location_on"
        />
        <Layout.Stack
          css={{
            marginLeft: '4px',
            color: '$core.color.neutral.0',
          }}
        >
          <LinkWithTracking
            after={
              <IconSymbol
                color="$core.color.brand.100"
                css={{
                  'abyss-icon-symbol': {
                    width: '18px',
                    height: '18px',
                  },
                }}
                icon="keyboard_arrow_down"
              />
            }
            analyticsInfo={{
              location: 'body:locations',
            }}
            aria-label={`${abbreviateLocation(
              locationInputVal,
              stateCode,
              zipCode
            )}, Set location`}
            css={{ color: '$core.color.brand.100', lineHeight: '18px' }}
            data-auto-testid="user-location-current-location"
            data-testid="user-location-current-location"
            fontWeight="600"
            href={window.location.search}
            onClick={() => setIsOpenMobileLocation(true)}
            size="$sm"
            variant="default"
          >
            {abbreviateLocation(locationInputVal, stateCode, zipCode)}
          </LinkWithTracking>
        </Layout.Stack>
      </Flex>
    </Layout.Group>
  );
};
